import { Service, service } from './di'

@service
export class CookieyesService extends Service {
    init() {
        const firstScript = document.getElementsByTagName('script')[0]
        const cookieyesScript = document.createElement('script')
        cookieyesScript.id = 'cookieyes'
        cookieyesScript.type = 'text/javascript'
        cookieyesScript.async = true
        cookieyesScript.src =
            'https://cdn-cookieyes.com/client_data/455f82962bc443f2cec7c30f/script.js'
        firstScript.parentNode.insertBefore(cookieyesScript, firstScript)
    }
}
